export default __webpack_public_path__ + "static/media/eye-on.42edd76d.svg";